import styled from 'styled-components/macro'
import { Form } from 'formik'

export const FormLayout = styled(Form)``

export const FormWrapper = styled.div`
  margin-top: 1rem;
`
